/**
 * The one line that loads expo-local-authentication.
 *
 * Isolated in its own module for two reasons.
 *
 * Safety: importing this package is what crashed the app on 2026-08-12 — its
 * entry point calls `requireNativeModule('ExpoLocalAuthentication')` at module
 * scope, which throws on any binary built before the package existed. Keeping
 * the load behind a function in a module of its own makes it obvious that
 * nothing may import it until the native side has been confirmed present. See
 * `getLocalAuth` in lib/app-lock.ts, which is the only caller.
 *
 * Testability: a bare `require` cannot be intercepted under vitest, so the
 * store-build path would otherwise be untestable. Mocking this module lets the
 * suite exercise both populations — binaries with and without the native
 * module — instead of only the one that happens to be reachable.
 */

export type LocalAuthModule = {
    hasHardwareAsync: () => Promise<boolean>;
    isEnrolledAsync: () => Promise<boolean>;
    authenticateAsync: (opts?: Record<string, unknown>) => Promise<{ success: boolean }>;
};

/**
 * Requires the package. ONLY call this once the native module is known to
 * exist — on a binary without it, this throws.
 */
export function loadLocalAuthModule(): LocalAuthModule {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require("expo-local-authentication") as LocalAuthModule;
}
